import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../../utils/styles";
import { ActionsType, GridItemInterface } from "./types";

const Container = styled.div`
    margin: 0 0 0 -0.5em;
    overflow-x: auto;
    padding: 0 0.5em 1em;
    // width: 112%;
    
    @media screen and (min-width: ${breakpoints.desktop}px) {
        margin: 0 -0.5em;
        width: 100%;
    }
`;

const Item = styled.li`
    flex: 0 0 40%;
    margin-right: 1rem;
    overflow: hidden;
    position: relative;

    @media screen and (min-width: ${breakpoints.desktop}px) {
        flex: none;
        margin-right: 0;
    }
`;

const List = styled.ul<{grid?: boolean}>`
    ${props => props.grid
        ? `
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1em;
        `
        : `display: flex;`}
    list-style-type: none;
    margin: 0 !important;
    padding: 0;
        
    ${Item} { ${props => props.grid && 'margin-right: 0;'} }

    @media screen and (min-width: ${breakpoints.desktop}px) {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 1em;
    }
`;

interface Props {
    items: Array<GridItemInterface>,
    grid?: boolean,
    actions: ActionsType,
    RenderItem: React.ComponentType<{item: GridItemInterface, actions: ActionsType}>,
}

function CatalogBlockGrid({items, grid, actions, RenderItem}: Props) {
    if (!items.length) {
        return null;
    }

    return <Container>
        <List grid={grid}>
            {items.map((item:GridItemInterface) => <Item><RenderItem key={item.id} item={item} actions={actions} /></Item>)}
        </List>
    </Container>;
}

export default CatalogBlockGrid;